// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"AC8xmkmI7ZNy-XnHE9u-P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Calendar/components/Week.mod.css
// module id = 1025
// module chunks = 0